import * as angular from "angular";
import {IController, ITimeoutService, IWindowService} from "angular";
import * as _ from "lodash";
import {FulfillmentTotalsModel} from "../../models/fulfillment-totals.model";
import {FulfillmentStepDisplayStatusGroupType} from "../../types/fulfillment-step-display-status-group.type";
import {FulfillmentStepActionType} from "../../types/fulfillment-step-action.type";
import {ThreePLTrainService} from "../../../threePL/angular/services/threepl-train.service";
import {TrainContainerDetails} from "../../../threePL/models/train-container-details.model";
import {ThreePlExtraData} from "../../../threePL/models/threepl-extra-data.model";
import {ExportType} from "../../../commons/types/export.type";
import {ThreePLProviderType} from "../../../threePL/types/threePL-provider.type";
import {PlanProjectEntity} from "../../../planning/models/plan-project-entity.model";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {OmsService} from "../../../oms/services/oms-service.service";
import {PlanningDialogService} from "../../../planning/services/planning-dialogs-service.service";
import {PlanningProjectsService} from "../../../planning/services/planning-projects-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {FulfillmentAlertsService} from "../../services/fulfillment-alerts.service";
import {FulfillmentDialogService} from "../../services/fulfillment-dialogs-service.service";
import {FulfillmentService} from "../../services/fulfillment-service.service";
import {FulfillmentStepService} from "../../services/fulfillment-step-service.service";
import {
  CancellationReasonsDialogsService
} from "../../../cancellation-reasons/services/cancellation-reasons-dialogs-service.service";
import {CancellationReason} from "../../../cancellation-reasons/models/cancellationReason.model";
import {DeliveriesDialogService} from "../../../deliveries/services/deliveries-dialog-service.service";
import {FulfillmentSubTypeType} from "../../types/fulfillment-sub-type.type";
import {FulfillmentFacadeService} from "../../angular/services/fulfillment-facade.service";
import {Subscription} from "rxjs";
import {PaginationModel} from "../../../commons/angular/models/pagination.model";
import {FulfillmentModel} from "../../models/fulfillment.model";
import {
  ActionReasonsDialogsServiceService
} from "../../../action-reasons/services/action-reasons-dialogs-service.service";
import {ActionReasonEntityEnum} from "../../../action-reasons/enums/action-reason-entity.enum";
import {TrainCarDetails} from "../../../threePL/models/train-car-details.model";
import {ThreePLAlertsService} from "../../../threePL/services/threePL-alerts.service";
import {EXPORT_CSV_SIZE_LIMIT, EXPORT_EXCEL_SIZE_LIMIT} from "../../../commons/angular/constants/commons";

export class fulfillmentLinesView implements IController {

  fulfillmentId: string;
  dateRangeTemplateType?: DateRangeTemplateType;
  from: any;
  to: any;
  isLinesView: boolean;
  schedulingRequired: boolean;
  isReturnDelivery: boolean;
  obligateTimeWindow: boolean;
  accountIds: string[];
  branchIds: string[];
  serviceAreaIds: string[];
  tags: string[];
  programTypes: string[];
  packagesIds: string[];
  logisticsVehicleIds: string[];
  inRoute: any;
  serviceTypes: string[];
  approvalStatuses: string[];
  depotIds: string[];
  agentIds: string[];
  fulfillmentStepDisplayStatus: string[];
  fulfillmentMileType: string;
  filterByCreatedAt: boolean;
  noFromLocation: boolean;
  noToLocation: boolean;
  displayStatusGroups: FulfillmentStepDisplayStatusGroupType[];
  selectedQuickFilterId: string;
  doDispatch: boolean;
  dispatchType: string[];
  noPickUpArea?: boolean;
  noDropOffArea?: boolean;
  noPickUpDepot?: boolean;
  noDropOffDepot?: boolean;
  noPickUpAccount?: boolean;
  noDropOffAccount?: boolean;

  public pageName: string;
  public filtersConfig = {
    dateRangeTemplateType: undefined,
    customTemplates: undefined,
    includeFilters: undefined,
    bringozFilters: undefined,
    range: {
      name: undefined,
      dateStart: undefined,
      dateEnd: undefined
    },
    rangeLimit: {
      min: undefined,
      max: undefined
    },
    siteId: undefined,
    filterByCreatedAt: undefined,
    settings: undefined,
  };
  private selectedFulfillment: FulfillmentModel;
  private steps: any;
  private isFullFulfillmentLinesView: boolean = false;
  private size: number = 20;
  private page: number = 0;
  // private fulfillments: any;
  public isLoading: boolean;
  public isLoadingSubscription: Subscription;
  public selectedSteps: any[] = [];
  public selectedFulfillments: FulfillmentModel[] = [];
  public selectedFulfillmentIds: string[] = []
  public excludeMode: boolean = false;
  public isLinesTableScrollable: boolean = false;
  public isStepsTableScrollable: boolean = false;
  public searchTerm: string;
  public fulfillmentsTotals: FulfillmentTotalsModel;
  public selectedTotalsFilter: any = {};
  public fulfillmentsTotalsType: typeof FulfillmentStepDisplayStatusGroupType = FulfillmentStepDisplayStatusGroupType;
  private blockingSearchDatesRangeLimit: number;
  public bulkActions: any;
  public fulfillmentStepActionType: typeof FulfillmentStepActionType = FulfillmentStepActionType;
  public exportType: typeof ExportType = ExportType;
  public threePlExtraData: ThreePlExtraData;
  public containers: TrainContainerDetails[];
  public isMobileView: boolean;
  public selectedStepIds: string[];
  public allowSendToPlanning: boolean;

  public fulfillmentStepsGroupStatuses: object;
  public fulfillmentsPaginatedResultsSubscription: Subscription;
  public isInitializedFulfillmentsSubscription: Subscription;
  public isInitializedFulfillments: boolean;
  public selectedFulfillmentSubscription: Subscription;
  public fulfillments: FulfillmentModel[];
  public fulfillmentsPagination: PaginationModel;
  public selectedStatus: any;


  constructor(private fulfillmentStepService: FulfillmentStepService, private splitService, private planningConstants, private $mdMedia, private fulfillmentService: FulfillmentService,
              private $log, private fulfillmentDialogService: FulfillmentDialogService, private $window: IWindowService, private $state, private dateRangeTimeFiltersService: DateRangeTimeFiltersService,
              private $timeout: ITimeoutService, private planningDialogService: PlanningDialogService, private planningProjectsService: PlanningProjectsService, private fulfillmentAlertsService: FulfillmentAlertsService, private omsService: OmsService,
              private filePrinter, private fileDownloader, private DeliveriesApiAction, private moment, private actionReasonsDialogsService: ActionReasonsDialogsServiceService,
              private threePLTrainService: ThreePLTrainService, private confirmDialogService: ConfirmDialogService, private quickFilterContextService: QuickFilterContextService,
              private viewFilterSettingsService: ViewFilterSettingsService, private IAMPermissions, private deliveriesDialogService: DeliveriesDialogService,
              private FulfillmentConstants, private fulfillmentFacadeService: FulfillmentFacadeService, private threePLAlertsService: ThreePLAlertsService) {
    this.blockingSearchDatesRangeLimit = this.splitService.getBlockingSearchDatesRangeLimit();
    this.pageName = this.$state.current.name;
  }

  $onInit() {
    this.fulfillmentStepsGroupStatuses = this.FulfillmentConstants.fulfillmentStepsGroupStatuses;
    this.allowSendToPlanning = !this.IAMPermissions.hasPermission('threePL.list');

    this.selectedFulfillment = undefined;
    this.steps = undefined;

    this.filtersConfig.settings = this.splitService.getSiteFulfillmentSettings(this.splitService.getSiteId());
    this.filtersConfig.customTemplates = this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates();
    this.filtersConfig.range = this.dateRangeTemplateType ? this.dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType) :
      ((this.from && this.to) ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today());
    this.filtersConfig.rangeLimit = {
      min: !this.blockingSearchDatesRangeLimit ? undefined : this.moment().subtract(this.blockingSearchDatesRangeLimit, 'day').startOf('day').valueOf(),
      max: undefined,
    };

    this.filtersConfig.includeFilters = [SiteFiltersType.dateRangeTemplateType, SiteFiltersType.accountIds, SiteFiltersType.schedulingRequired, SiteFiltersType.obligateTimeWindow,
      SiteFiltersType.branchIds, SiteFiltersType.serviceAreaIds, SiteFiltersType.tags, SiteFiltersType.programTypes, SiteFiltersType.inRoute, SiteFiltersType.serviceTypes,
      SiteFiltersType.fulfillmentStepDisplayStatus, SiteFiltersType.depotIds, SiteFiltersType.fulfillmentMileType, SiteFiltersType.agentIds, SiteFiltersType.packagesIds,
      SiteFiltersType.logisticsVehicleIds, SiteFiltersType.approvalStatuses, SiteFiltersType.isReturnDelivery, SiteFiltersType.noFromLocation, SiteFiltersType.noToLocation, SiteFiltersType.dispatchType,
      SiteFiltersType.serviceAreaPickup, SiteFiltersType.serviceAreaDropoff, SiteFiltersType.depotPickup, SiteFiltersType.depotDropoff, SiteFiltersType.accountPickup,
      SiteFiltersType.accountDropoff, SiteFiltersType.noPickUpArea, SiteFiltersType.noDropOffArea, SiteFiltersType.noPickUpDepot, SiteFiltersType.noDropOffDepot, SiteFiltersType.noPickUpAccount,
      SiteFiltersType.noDropOffAccount];

    this.filtersConfig.filterByCreatedAt = this.filterByCreatedAt;

    this.filtersConfig.bringozFilters = {
      [SiteFiltersType.dateRangeTemplateType]: this.dateRangeTemplateType,
      [SiteFiltersType.accountIds]: this.accountIds || [],
      [SiteFiltersType.schedulingRequired]: this.schedulingRequired,
      [SiteFiltersType.noFromLocation]: this.noFromLocation,
      [SiteFiltersType.noToLocation]: this.noToLocation,
      [SiteFiltersType.obligateTimeWindow]: this.obligateTimeWindow,
      [SiteFiltersType.isReturnDelivery]: this.isReturnDelivery,
      [SiteFiltersType.branchIds]: this.branchIds || [],
      [SiteFiltersType.serviceAreaIds]: this.serviceAreaIds || [],
      [SiteFiltersType.tags]: this.tags || [],
      [SiteFiltersType.depotIds]: this.depotIds || [],
      [SiteFiltersType.agentIds]: this.agentIds || [],
      [SiteFiltersType.programTypes]: this.programTypes || [],
      [SiteFiltersType.packagesIds]: this.packagesIds || [],
      [SiteFiltersType.approvalStatuses]: this.approvalStatuses || [],
      [SiteFiltersType.logisticsVehicleIds]: this.logisticsVehicleIds || [],
      [SiteFiltersType.inRoute]: this.inRoute,
      [SiteFiltersType.serviceTypes]: this.serviceTypes || [],
      [SiteFiltersType.fulfillmentStepDisplayStatus]: this.fulfillmentStepDisplayStatus || [],
      [SiteFiltersType.fulfillmentMileType]: this.fulfillmentMileType,
      [SiteFiltersType.displayStatusGroups]: this.displayStatusGroups || [],
      [SiteFiltersType.dispatchType]: this.dispatchType,
      [SiteFiltersType.noPickUpArea]: this.noPickUpArea,
      [SiteFiltersType.noDropOffArea]: this.noDropOffArea,
      [SiteFiltersType.noPickUpDepot]: this.noPickUpDepot,
      [SiteFiltersType.noDropOffDepot]: this.noDropOffDepot,
      [SiteFiltersType.noPickUpAccount]: this.noPickUpAccount,
      [SiteFiltersType.noDropOffAccount]: this.noDropOffAccount,
    }

    _.forEach(this.filtersConfig.bringozFilters.displayStatusGroups, (status: any) => {
      this.selectedTotalsFilter[status] = true;
    })

    this._initFulfillments(false);
    if (this.fulfillmentId) {
      this.fulfillmentFacadeService.getOne(this.fulfillmentId, true);

      //The reason we need this is because the view can open as table or as fulfillment view drill down and the fulfillment is part of the url query params
      this.selectedFulfillmentSubscription = this.fulfillmentFacadeService.selectOne(this.fulfillmentId)
        .subscribe((fulfillment: FulfillmentModel) => {
          if (!!fulfillment) {
            this.selectedFulfillment = angular.copy(fulfillment);
            this._addStepNumberToFulfillment(this.selectedFulfillment);
            this.$timeout(0).then(() => {
            });
          }
        })

      this.isFullFulfillmentLinesView = true;
    }

    this.fulfillmentsPaginatedResultsSubscription = this.fulfillmentFacadeService.selectPaginatedResults()
      .subscribe((paginatedResult: { pagination: PaginationModel, fulfillments: FulfillmentModel[] }) => {
        this.fulfillments = angular.copy(paginatedResult.fulfillments);
        this.fulfillmentsPagination = angular.copy(paginatedResult.pagination);
        this.fulfillments?.forEach((fulfillment: any) => this._addStepNumberToFulfillment(fulfillment));
        this.$timeout(0).then(() => {
        });
      })

    this.isInitializedFulfillmentsSubscription = this.fulfillmentFacadeService.selectInitialized()
      .subscribe((initialized) => {
        this.isInitializedFulfillments = initialized;
        this.$timeout(0).then(() => {
        });
      });

    this.isLoadingSubscription = this.fulfillmentFacadeService.selectIsLoading()
      .subscribe((isLoading) => {
        this.isLoading = isLoading;
        this.$timeout(0).then(() => {
        });
      });

    this.fulfillmentFacadeService.subscribeToChannels();
  }

  $doCheck() {
    const enabledLinesColumns = _.pickBy(_.get(this.filtersConfig, 'settings.linesColumns', {}), (c) => {
      return !!c.enabled
    });
    const enabledDynamicColumns = _.filter(_.get(this.filtersConfig, 'settings.dynamicColumns', []), (dc) => {
      return !!dc.enabled
    });
    const numberOfLinesColumns = _.size(enabledLinesColumns) + enabledDynamicColumns.length;

    // this.isLinesTableScrollable = (!this.$mdMedia('gt-sm') || numberOfLinesColumns > 8);
    this.isLinesTableScrollable = true;

    const enabledStepsColumns = _.pickBy(_.get(this.filtersConfig, 'settings.stepsColumns', {}), (c) => {
      return !!c.enabled
    });
    const numberOfStepsColumns = _.size(enabledStepsColumns) + enabledDynamicColumns.length;
    this.isStepsTableScrollable = (!this.$mdMedia('gt-sm') || numberOfStepsColumns > 8);

    this.isMobileView = this.$mdMedia('xs');
  }

  $onDestroy() {
    this.fulfillmentFacadeService.removeAll();
    this.fulfillmentsPaginatedResultsSubscription.unsubscribe();
    this.isInitializedFulfillmentsSubscription?.unsubscribe();
    this.isLoadingSubscription?.unsubscribe();
    this.selectedFulfillmentSubscription?.unsubscribe();
  }

  onOpen(fulfillment) {
    this.selectedFulfillmentSubscription?.unsubscribe();

    if (_.isEqual(_.get(this.selectedFulfillment, 'id'), fulfillment.id)) {
      this.selectedFulfillment = undefined;
    } else {
      this.selectedFulfillmentSubscription = this.fulfillmentFacadeService.selectOne(fulfillment.id)
        .subscribe((fulfillment: FulfillmentModel) => {
          if (!!fulfillment) {
            this.selectedFulfillment = angular.copy(fulfillment);
            this._addStepNumberToFulfillment(this.selectedFulfillment);
            this.$timeout(0).then(() => {
            });
          }
        })
    }
    // this.selectedFulfillment = _.isEqual(_.get(this.selectedFulfillment, 'id'), fulfillment.id) ? undefined : fulfillment;
    this._setStateParams();
  }

  onFilterTotalsStatus(status) {
    this.selectedStatus = status;

    if (status === this.fulfillmentsTotalsType.total) {
      if (_.includes(this.filtersConfig.bringozFilters.displayStatusGroups, this.fulfillmentsTotalsType.total)) {
        return;
      } else {
        this.filtersConfig.bringozFilters.displayStatusGroups = [this.fulfillmentsTotalsType.total];
      }
    } else {
      if (_.includes(this.filtersConfig.bringozFilters.displayStatusGroups, status)) {
        const statusIndex = _.findIndex(this.filtersConfig.bringozFilters.displayStatusGroups, s => {
          return s === status;
        })
        this.filtersConfig.bringozFilters.displayStatusGroups.splice(statusIndex, 1);
      } else {
        this.filtersConfig.bringozFilters.displayStatusGroups.push(status);
      }
    }

    if (!this.displayStatusGroups?.length) {
      this.filtersConfig.bringozFilters.displayStatusGroups = [this.fulfillmentsTotalsType.total];
    } else if (this.filtersConfig.bringozFilters.displayStatusGroups?.length > 1 && _.includes(this.filtersConfig.bringozFilters.displayStatusGroups, this.fulfillmentsTotalsType.total)) {
      this.filtersConfig.bringozFilters.displayStatusGroups = _.filter(this.filtersConfig.bringozFilters.displayStatusGroups, (status) => {
        return status !== this.fulfillmentsTotalsType.total;
      });
    }

    this.selectedTotalsFilter = {};
    _.forEach(this.filtersConfig.bringozFilters.displayStatusGroups, (status: any) => {
      this.selectedTotalsFilter[status] = true;
    })

    this.page = 0;
    this._setStateParams();
    this._initFulfillments(true);
  }

  isFilterByFulfillmentStepDisplayStatus(status) {
    return _.includes(this.filtersConfig.bringozFilters.fulfillmentStepDisplayStatus, status) && this.filtersConfig.bringozFilters.fulfillmentStepDisplayStatus.length !== 8;
  }

  onQueryChange(searchTerm) {
    this.searchTerm = searchTerm;
    this.page = 0;
    this._initFulfillments(true);
  }

  onDispatch(fulfillment, stepIds?, event?) {
    this.fulfillmentDialogService.dispatchStep(fulfillment, stepIds, event)
      .then(() => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(updatedFulfillment => {
            this._updateFulfillment(fulfillment, updatedFulfillment);
          })
      })
      .catch((error) => {
        this.$log.debug('Failed to dispatch step', error);
      })
  }

  onDateSortByChange() {
    this.selectedSteps = [];
    this.selectedFulfillments = [];
    this.excludeMode = false;
    this.page = 0;
    this._setStateParams();
    this._initFulfillments(true);
  }

  onToggleFullView() {
    this.isFullFulfillmentLinesView = true;
  }

  onToggleBack() {
    if (!this.isFullFulfillmentLinesView && this.selectedFulfillment) {
      this.selectedFulfillmentSubscription?.unsubscribe();
      this.isFullFulfillmentLinesView = false;
      this.selectedFulfillment = undefined;
      this._setStateParams();
    } else {
      this.isFullFulfillmentLinesView = false;
    }
  }

  toggleView() {
    this.isLinesView = !this.isLinesView;
  }

  onViewSettingsChange(settings) {
    this.filtersConfig.settings = settings;
    this.splitService.setSiteFulfillmentSettings(settings);

    this.fulfillmentAlertsService.viewSettingsChangesSuccess();
  }


  onPaginationBrowse(isNext) {
    if (isNext) {
      this.page += 1;
    } else {
      if (this.page === 0) {
        return;
      }
      this.page -= 1;
    }
    this._initFulfillments(true);
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {

    this.allowSendToPlanning = !this.allowSendToPlanning && filters.dispatchType === FulfillmentSubTypeType.Dispatch

    this.selectedSteps = [];
    this.selectedFulfillments = [];
    this.excludeMode = false;
    this.filtersConfig.bringozFilters = filters;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;

    if (!!filters.dateRangeTemplateType) {
      this.filtersConfig.range = this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    }

    this.page = 0;
    this._setStateParams();
    this._initFulfillments(true);
  }

  onRangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.filtersConfig.range.name)) {
      this.selectedSteps = [];
      this.selectedFulfillments = [];
      this.excludeMode = false;
      this.filtersConfig.range = range;

      if (this.selectedQuickFilterId && range.type !== this.filtersConfig.bringozFilters.dateRangeTemplateType) {
        this.selectedQuickFilterId = undefined;
      }

      this.filtersConfig.bringozFilters.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;
      this.page = 0;
      this._setStateParams();
      this._initFulfillments(true);
    }
  }

  onSelectStepsChanged(selectedSteps, selectedFulfillments, excludeMode) {
    this.selectedFulfillments = selectedFulfillments;
    this.selectedSteps = selectedSteps;

    this.selectedFulfillmentIds = selectedFulfillments.map(f => f.id);
    this.selectedStepIds = selectedSteps.map(s => s.id);

    this.excludeMode = excludeMode;
  }

  onToggleSelectStep(step) {
    const stepIndex = _.findIndex(this.selectedSteps, selectedStep => {
      return selectedStep.id === step.id;
    })
    const selectedSteps = angular.copy(this.selectedSteps);

    if (stepIndex > -1) {
      selectedSteps.splice(stepIndex, 1);
    } else {
      selectedSteps.push(step);
    }

    this.selectedSteps = selectedSteps;
  }

  onCancelOrder(orderId, fulfillment, event) {
    this.omsService.onCancelOrder(orderId, event)
      .then(res => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(updatedFulfillment => {
            this._updateFulfillment(fulfillment, updatedFulfillment);
          })
      });
  }

  onSetOrderOnHold(orderId, fulfillment) {
    this.omsService.onSetOrderOnHold(orderId)
      .then(res => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(updatedFulfillment => {
            this._updateFulfillment(fulfillment, updatedFulfillment);
          })
      })
  }

  onEditOrder(orderId) {
    const siteId = this.splitService.getSiteId();
    const url = this.$state.href('order.edit', {id: orderId, siteId: siteId});
    this.$window.open(url, '_blank');
  }

  onRestoreFulfillment(fulfillment, $event) {
    if (!fulfillment.serviceTemplateId) {
      this.fulfillmentService.restoreFulfillment(fulfillment.id, false);
      return;
    }
    this.fulfillmentDialogService.restoreFulfillments([fulfillment.id], $event)
      .then((copyStepTemplateId) => {
        this.fulfillmentService.restoreFulfillment(fulfillment.id, copyStepTemplateId);
      })
  }

  onDuplicateOrder(orderId) {
    const siteId = this.splitService.getSiteId();
    const url = this.$state.href('order.duplicate', {id: orderId, siteId: siteId});
    this.$window.open(url, '_blank');
  }

  onAddOrderNote(orderId, fulfillment, event) {
    this.omsService.onAddNote(event, orderId);
  }

  onPrintBillOfLading(orderId) {
    this.omsService.onGetBOLOrderIdToPdf(orderId)
      .then((res: any) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.filePrinter(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  onDownloadBillOfLading(orderId) {
    this.omsService.onGetBOLOrderIdToPdf(orderId)
      .then((res: any) => {
        if (res.data) {
          let fileName = res.headers('content-disposition').split('filename = ')[1];
          this.fileDownloader(res.data, fileName, _.get(res.headers(), "content-type"))
        }
      })
  }

  onAutoAssignService(serviceId, $event, fulfillment) {
    this.DeliveriesApiAction.autoAssignAgent($event, serviceId)
      .then(() => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(updatedFulfillment => {
            this._updateFulfillment(fulfillment, updatedFulfillment);
          })
      })
  }

  onAutoAssignServices(event) {
    this.DeliveriesApiAction.autoAssignAgent(event, this.getSelectedStepsServicesIds(this.selectedSteps));

    this.selectedFulfillments = [];
    this.selectedSteps = [];
    this.selectedFulfillmentIds = [];
    this.selectedStepIds = [];
  }

  onAssignAgentToService(serviceId, $event, fulfillment) {
    this.DeliveriesApiAction.assignAgent($event, serviceId)
      .then(() => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(updatedFulfillment => {
            this._updateFulfillment(fulfillment, updatedFulfillment);
          })
      });
  }

  onAssignAgentToServices(event) {
    this.DeliveriesApiAction.assignAgent(event, this.getSelectedStepsServicesIds(this.selectedSteps));

    this.selectedFulfillments = [];
    this.selectedSteps = [];
    this.selectedFulfillmentIds = [];
    this.selectedStepIds = [];
  }

  onCancelService(serviceId, serviceType, $event, fulfillment) {
    this.DeliveriesApiAction.cancel($event, serviceId, serviceType)
      .then(() => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(updatedFulfillment => {
            this._updateFulfillment(fulfillment, updatedFulfillment);
          })
      })
  }

  onRestoreFulfillments(event) {
    if (this.selectedFulfillments.length === 1 && !this.selectedFulfillments[0].serviceTemplateId) {
      this.fulfillmentService.restoreFulfillment(this.selectedFulfillments[0].id, false);

      this.selectedFulfillments = [];
      this.selectedSteps = [];
      this.selectedFulfillmentIds = [];
      this.selectedStepIds = [];
      return;
    }

    let payload;

    if (this.excludeMode) {
      payload = {
        filter: {
          stepFilter: this._getStepFilterPayload(),
          fulfillmentFilter: {
            packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
          },
          searchTerm: this.searchTerm
        }
      };
    } else {
      payload = {
        fulfillmentIds: this.selectedFulfillmentIds
      };
    }

    this.fulfillmentDialogService.restoreFulfillments(this.selectedFulfillmentIds, event)
      .then((copyStepTemplateId) => {
        this.fulfillmentService.bulkRestoreFulfillments(payload, copyStepTemplateId);

        this.selectedFulfillments = [];
        this.selectedSteps = [];
        this.selectedFulfillmentIds = [];
        this.selectedStepIds = [];
      })

  }

  onResetService(serviceId, serviceType, $event, fulfillment) {
    this.DeliveriesApiAction.reset($event, serviceId, serviceType)
      .then(() => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(updatedFulfillment => {
            this._updateFulfillment(fulfillment, updatedFulfillment);
          })
      })
  }

  onResetServices(event) {
    this.DeliveriesApiAction.reset(event, this.getSelectedStepsServicesIds(this.selectedSteps));

    this.selectedFulfillments = [];
    this.selectedSteps = [];
    this.selectedFulfillmentIds = [];
    this.selectedStepIds = [];
  }

  onCancelSteps(event) {
    this.confirmDialogService.confirm('Confirm Legs Cancellation',
      'Upon canceling a Leg, the associated packages will not form a gap, the Order will remain unchanged, however,' +
      ' this action might impact related Legs or Lines. Are you sure you want to proceed?', event)
      .then(() => {
        this._onCancelSteps(this.selectedStepIds);

        this.selectedFulfillments = [];
        this.selectedSteps = [];
        this.selectedFulfillmentIds = [];
        this.selectedStepIds = [];
      })
  }

  onAddServicesToRoute(event) {
    this.DeliveriesApiAction.assignRoute(event, this.getSelectedStepsServicesIds(this.selectedSteps));

    this.selectedFulfillments = [];
    this.selectedSteps = [];
    this.selectedFulfillmentIds = [];
    this.selectedStepIds = [];
  }

  onAssignRouteToService(serviceId, $event, fulfillment) {
    this.DeliveriesApiAction.assignRoute($event, serviceId)
      .then(() => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(updatedFulfillment => {
            this._updateFulfillment(fulfillment, updatedFulfillment);
          })
      })
  }

  onAddServicesToResource(event) {
    this.DeliveriesApiAction.assignResourceAllocation(event, this.getSelectedStepsServicesIds(this.selectedSteps));


    this.selectedFulfillments = [];
    this.selectedSteps = [];
    this.selectedFulfillmentIds = [];
    this.selectedStepIds = [];
  }

  onAssignResourceAllocation(serviceId, $event, fulfillment) {
    this.DeliveriesApiAction.assignResourceAllocation($event, serviceId)
      .then(() => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(updatedFulfillment => {
            this._updateFulfillment(fulfillment, updatedFulfillment);
          })
      })
  }

  onCompleteStepManually(stepId, $event, fulfillment) {
    this.fulfillmentDialogService.manualHandle($event, stepId)
      .then((note) => {
        this._manualHandleFulfillmentSteps([stepId], note);
      })
      .catch((error) => {
        this.$log.debug('Dialog Closed');
      })
  }

  onAddNoteToService(serviceId, $event, fulfillment) {
    this.DeliveriesApiAction.note($event, serviceId);
  }

  onCreateRoute(serviceId, $event, fulfillment) {
    this.DeliveriesApiAction.createRoute($event, [serviceId])
      .then(() => {
        this.fulfillmentService.getFulfillment(fulfillment.id, true)
          .then(updatedFulfillment => {
            this._updateFulfillment(fulfillment, updatedFulfillment);
          })
      });
  }

  onOpenActionsMenu($mdMenu, ev) {
    this.bulkActions = this.fulfillmentService.fulfillmentsActions(this.selectedSteps);
    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }

  onBulkSendToDispatch() {
    this.fulfillmentDialogService.bulkDispatch()
      .then(data => {
        this.bulkDispatch(data);
        this.selectedFulfillments = [];
        this.selectedSteps = [];

        this.selectedFulfillmentIds = [];
        this.selectedStepIds = [];

      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onCreateVoucher(stepsForVoucher?) {

    if (!!stepsForVoucher?.length) {
      this.selectedSteps = stepsForVoucher;
    }

    let steps = angular.copy(this.selectedSteps);

    _.forEach(steps, (s) => {
      const fulfillment = _.find(this.fulfillments, (f) => {
        return f.id === s.fulfillmentId;
      })

      if (!!fulfillment) {
        s.items = _.map(s.items, (stepItem) => {
          const itemIndex = _.findIndex(fulfillment.items, (item: any) => {
            return item.id === stepItem.id;
          })
          if (itemIndex > -1) {
            const containerItem = angular.copy(fulfillment.items[itemIndex]);
            containerItem.count = stepItem.count;

            return containerItem
          }
        })
      }
    })
    this.containers = this.threePLTrainService.getContainersBySteps(steps);
    this.threePlExtraData = {
      type: ThreePLProviderType.TrainIL,
      name: undefined,
      carsDetails: [],
      approvalStatus: undefined,
      pickupDepotId: _.get(steps, '[0].pickup.depotReference.id'),
      destinationDepotId: _.get(steps, '[0].destination.depotReference.id'),
      pickupTrainStation: undefined,
      destinationTrainStation: undefined
    }

    // this.$state.go('threePL.train.create-voucher', {stepsIds: _.map(this.selectedSteps, 'id')});
  }

  onSendToPlanning(event) {
    this.planningDialogService.createOrSelectProject(event, false, undefined, undefined, true)
      .then((payload: { project: PlanProjectEntity, projectId: string }) => {
        if (payload.project) {
          this._createProjectWithSteps(payload.project);
        }
        if (payload.projectId) {
          this._sendStepsToExistingProject(payload.projectId);
        }

        this.selectedFulfillments = [];
        this.selectedSteps = [];
        this.selectedFulfillmentIds = [];
        this.selectedStepIds = [];

      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onExport(event, exportType) {
    let count = 0;
    const selectedStatuses: FulfillmentStepDisplayStatusGroupType[] = this._getSelectedStatuses();

    for (const status of selectedStatuses) {
      const matchedKey = Object.keys(this.fulfillmentsTotals).find(
        key => key.toLowerCase() === status.toLowerCase()
      );

      if (matchedKey && this.fulfillmentsTotals[matchedKey]) {
        count += this.fulfillmentsTotals[matchedKey];
      }
    }

    const text = 'Are you sure you want to export steps?';
    let extraText;

    if (exportType === ExportType.Excel) {
      if (count > EXPORT_EXCEL_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export Steps to File', text, extraText, {x: EXPORT_EXCEL_SIZE_LIMIT}, event)
        .then(() => {
          this._onExport(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    } else if (ExportType.CSV) {
      if (count > EXPORT_CSV_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export Steps to File', text, extraText, {x: EXPORT_CSV_SIZE_LIMIT}, event)
        .then(() => {
          this._onExport(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    }

  }

  onCompleteStepsManually(event) {
    this.fulfillmentDialogService.manualHandle(event)
      .then((note) => {
        this._manualHandleFulfillmentSteps(this.selectedStepIds, note);


        this.selectedFulfillments = [];
        this.selectedSteps = [];
        this.selectedFulfillmentIds = [];
        this.selectedStepIds = [];
      })
  }

  onAddToRoute(event) {
    this.DeliveriesApiAction.assignRoute(event, this.getSelectedStepsServicesIds(this.selectedSteps));
  }

  onAssignAgent(event) {
    this.DeliveriesApiAction.assignAgent(event, this.getSelectedStepsServicesIds(this.selectedSteps));
  }

  onMultiAssignToAgent(event) {
    this.deliveriesDialogService.multipleAssignToAgent(event, this.selectedSteps);



    this.selectedFulfillments = [];
    this.selectedSteps = [];
    this.selectedFulfillmentIds = [];
    this.selectedStepIds = [];
  }

  onAddToResource(event) {
    this.DeliveriesApiAction.assignResourceAllocation(event, this.getSelectedStepsServicesIds(this.selectedSteps));
  }

  onCancelServices(event) {
    this.actionReasonsDialogsService.createThreeplServiceCancelReason(undefined, event, undefined, undefined, [ActionReasonEntityEnum.Delivery, ActionReasonEntityEnum.Operation])
      .then((payload) => {
        this._cancelServices(this.selectedStepIds, payload.cancelReason);

        this.selectedFulfillments = [];
        this.selectedSteps = [];
        this.selectedFulfillmentIds = [];
        this.selectedStepIds = [];
      })
  }

  onSelectedFulfillmentUpdate(updatedFulfillment) {
    this._updateFulfillment(this.selectedFulfillment, updatedFulfillment, true)
  }

  onSaveVoucher(threePlExtraData: ThreePlExtraData, supplierAccountId: string, date) {
    const stepIds = this.selectedSteps.length ? _.map(this.selectedSteps, 'id') : [];

    if (!stepIds.length) {
      threePlExtraData.carsDetails.forEach((car: TrainCarDetails) => {
        car.trainContainerDetails.forEach((c) => {
          if (!!c.stepId) {
            stepIds.push(c.stepId)
          }
        })
      })
    }

    this.threePLTrainService.createVoucher(threePlExtraData, supplierAccountId, stepIds, date, date)
      .then((steps: any[]) => {
        this.selectedSteps = [];
        this.selectedFulfillments = [];
        this.threePlExtraData = undefined;
        this.containers = undefined;
        this._initFulfillments(true);

        this.threePLAlertsService.trainVoucherCreateSuccess(true)
          .then((res) => {
            if (res) {
              const attempt: any = _.last(steps[0].attempts);
              const threeplServiceId = attempt?.referenceId;
              this.$state.go('threePL.train.vouchers', {serviceId: threeplServiceId})
            }
          });
      })
  }

  onFilterByType(type, value) {
    if (_.isArray(this.filtersConfig.bringozFilters[type])) {
      if (_.isArray(value)) {
        this.filtersConfig.bringozFilters[type] = _.uniq(this.filtersConfig.bringozFilters[type].concat(value));
      } else {
        if (!_.includes(this.filtersConfig.bringozFilters[type], value)) {
          this.filtersConfig.bringozFilters[type].push(value);
        }
      }
    } else {
      this.filtersConfig.bringozFilters[type] = value;
    }
    this._setStateParams();
    this._initFulfillments(true);
  }

  unSelectSteps() {
    this.excludeMode = false;
    this.selectedSteps = [];
    this.selectedStepIds = [];
  }


  private _cancelServices(stepIds: string[], cancellationReason: CancellationReason) {
    const payload = {
      reason: cancellationReason.reason,
      description: cancellationReason.description,
      comment: cancellationReason.comment,
      fulfillmentFilter: {
        stepFilter: this._getStepFilterPayload(),
        fulfillmentFilter: {
          packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
        },
        searchTerm: this.searchTerm
      }
    }

    if (this.excludeMode) {
      payload.fulfillmentFilter.stepFilter.excludeIds = stepIds;
      payload.fulfillmentFilter.stepFilter.includeIds = [];
    } else {
      payload.fulfillmentFilter.stepFilter.ids = stepIds;
    }

    this.fulfillmentStepService.cancelAttempt(payload);
  }

  private _manualHandleFulfillmentSteps(stepIds: string[], note: string) {
    const payload = {
      note: note,
      fulfillmentFilter: {
        stepFilter: this._getStepFilterPayload(),
        fulfillmentFilter: {
          packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
        },
        searchTerm: this.searchTerm
      }
    }

    if (this.excludeMode) {
      payload.fulfillmentFilter.stepFilter.excludeIds = stepIds;
      payload.fulfillmentFilter.stepFilter.includeIds = [];
    } else {
      payload.fulfillmentFilter.stepFilter.ids = stepIds;
    }
    this.fulfillmentStepService.manualHandleAttempt(payload);
  }

  private _onCancelSteps(stepIds: string[]) {
    this.fulfillmentStepService.cancelSteps(stepIds);
  }

  private _updateFulfillment(previousFulfillment, updatedFulfillment, isSelectedFulfillment?) {
    // _.forEach(updatedFulfillment.fulfillmentSteps, updatedStep => {
    //   const prevStep = _.find(previousFulfillment.fulfillmentSteps, previousStep => {
    //     return updatedStep.id === previousStep.id;
    //   })
    //   if (prevStep) {
    //     updatedStep.matchFilter = prevStep.matchFilter
    //   }
    // })
    // const fulfillmentIndex = _.findIndex(this.fulfillments, (fulfillment: any) => {
    //   return fulfillment.id === updatedFulfillment.id
    // })
    // const fulfillmentsCopy = angular.copy(this.fulfillments);
    // fulfillmentsCopy[fulfillmentIndex] = updatedFulfillment;
    // this.fulfillments = fulfillmentsCopy;
    // if (isSelectedFulfillment) {
    //   this.selectedFulfillment = updatedFulfillment;
    // }
  }

  private bulkDispatch(milesData) {

    const bulkActionsStepsData = this._bulkActionsData();

    const FulfillmentBulkDispatchRequest = {
      filter: {
        stepFilter: this._getStepFilterPayload(),
        fulfillmentFilter: {
          packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
        },
        searchTerm: this.searchTerm
      },
      timeWindowsPerLeg: {
        firstMile: {
          active: milesData.firstMile.active,
          pickupNotBefore: milesData.firstMile.isPerServiceOrTask === 'perService' ? milesData.firstMile.deliveryStartTime : milesData.firstMile.originStartTime,
          pickupNotAfter: milesData.firstMile.isPerServiceOrTask === 'perService' ? milesData.firstMile.deliveryEndTime : milesData.firstMile.originEndTime,
          destinationNotBefore: milesData.firstMile.deliveryStartTime,
          destinationNotAfter: milesData.firstMile.deliveryEndTime
        },
        middleMile: {
          active: milesData.middleMile.active,
          pickupNotBefore: milesData.middleMile.isPerServiceOrTask === 'perService' ? milesData.middleMile.deliveryStartTime : milesData.middleMile.originStartTime,
          pickupNotAfter: milesData.middleMile.isPerServiceOrTask === 'perService' ? milesData.middleMile.deliveryEndTime : milesData.middleMile.originEndTime,
          destinationNotBefore: milesData.middleMile.deliveryStartTime,
          destinationNotAfter: milesData.middleMile.deliveryEndTime
        },
        lastMile: {
          active: milesData.lastMile.active,
          pickupNotBefore: milesData.lastMile.isPerServiceOrTask === 'perService' ? milesData.lastMile.deliveryStartTime : milesData.lastMile.originStartTime,
          pickupNotAfter: milesData.lastMile.isPerServiceOrTask === 'perService' ? milesData.lastMile.deliveryEndTime : milesData.lastMile.originEndTime,
          destinationNotBefore: milesData.lastMile.deliveryStartTime,
          destinationNotAfter: milesData.lastMile.deliveryEndTime
        },
        manualBranchIds: milesData.manualBranchIds
      },
      sendSms: true
    };

    if (_.isEmpty(FulfillmentBulkDispatchRequest.filter.fulfillmentFilter)) {

      _.unset(FulfillmentBulkDispatchRequest.filter, 'fulfillmentFilter');
    }

    if (this.excludeMode) {
      FulfillmentBulkDispatchRequest.filter.stepFilter.excludeIds = bulkActionsStepsData.matchFilterStepsIds;
      FulfillmentBulkDispatchRequest.filter.stepFilter.includeIds = bulkActionsStepsData.isNotMatchFilterStepsIds;
    } else {
      FulfillmentBulkDispatchRequest.filter.stepFilter.ids = bulkActionsStepsData.selectedStepIds;
    }

    this.fulfillmentService.bulkDispatch(FulfillmentBulkDispatchRequest);

  }

  private _getStepFilterPayload() {
    return {
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      accountIds: this.filtersConfig.bringozFilters.accountIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      schedulingRequired: this.filtersConfig.bringozFilters.schedulingRequired,
      noFromLocation: this.filtersConfig.bringozFilters.noFromLocation,
      noToLocation: this.filtersConfig.bringozFilters.noToLocation,
      vehicleIds: this.filtersConfig.bringozFilters.logisticsVehicleIds,
      obligateTimeWindow: this.filtersConfig.bringozFilters.obligateTimeWindow,
      isReturn: this.filtersConfig.bringozFilters.isReturnDelivery,
      approvalStatuses: this.filtersConfig.bringozFilters.approvalStatuses,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      serviceAreaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      tags: this.filtersConfig.bringozFilters.tags,
      routed: this.filtersConfig.bringozFilters.inRoute,
      programTypes: this.filtersConfig.bringozFilters.programTypes,
      logisticsVehicleIds: this.filtersConfig.bringozFilters.logisticsVehicleIds,
      types: this.filtersConfig.bringozFilters.serviceTypes,
      displayStatuses: this.filtersConfig.bringozFilters.fulfillmentStepDisplayStatus,
      depotIds: this.filtersConfig.bringozFilters.depotIds,
      filterByCreatedAt: this.filtersConfig.filterByCreatedAt,
      firstMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'firstMile' ? true : undefined,
      middleMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'middleMile' ? true : undefined,
      lastMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'lastMile' ? true : undefined,
      displayStatusGroups: this.filtersConfig.bringozFilters.displayStatusGroups.filter(s => s !== 'Total'),
      excludeAttemptSubtypes: this.filtersConfig.bringozFilters.dispatchType ? (this.filtersConfig.bringozFilters.dispatchType === FulfillmentSubTypeType.ThirdParty ? [FulfillmentSubTypeType.Dispatch] : [FulfillmentSubTypeType.ThirdParty]) : undefined,
      excludeIds: [],
      includeIds: [],
      ids: []
    }
  }

  private _createProjectWithSteps(project) {

    const bulkActionsStepsData = this._bulkActionsData();

    const FulfillmentExtPlanningRequest = {
      filter: {
        stepFilter: this._getStepFilterPayload(),
        fulfillmentFilter: {
          packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
        },
        searchTerm: this.searchTerm
      },
      project: project
    };

    if (this.excludeMode) {
      FulfillmentExtPlanningRequest.filter.stepFilter.excludeIds = bulkActionsStepsData.matchFilterStepsIds;
      FulfillmentExtPlanningRequest.filter.stepFilter.includeIds = bulkActionsStepsData.isNotMatchFilterStepsIds;
    } else {
      FulfillmentExtPlanningRequest.filter.stepFilter.ids = bulkActionsStepsData.selectedStepIds;
    }

    this.planningProjectsService.createProjectWithFulfillments(FulfillmentExtPlanningRequest)
      .then((createdProject: any) => {
        this.$state.go(this.planningConstants.states.project, {projectId: createdProject.id});
      });
  }

  private _sendStepsToExistingProject(projectId: string) {
    const bulkActionsStepsData = this._bulkActionsData();

    const FulfillmentExtFilter = {
      stepFilter: this._getStepFilterPayload(),
      fulfillmentFilter: {
        packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
      },
    }


    if (this.excludeMode) {
      FulfillmentExtFilter.stepFilter.excludeIds = bulkActionsStepsData.matchFilterStepsIds;
      FulfillmentExtFilter.stepFilter.includeIds = bulkActionsStepsData.isNotMatchFilterStepsIds;
    } else {
      FulfillmentExtFilter.stepFilter.ids = bulkActionsStepsData.selectedStepIds;
    }

    this.planningProjectsService.addFulfillments(FulfillmentExtFilter, projectId).then(() => {
      this.$state.go(this.planningConstants.states.project, {projectId: projectId});
    })
  }

  private _setStateParams() {
    this.$state.go('.', {
      dateRangeTemplateType: this.filtersConfig.bringozFilters.dateRangeTemplateType,
      fulfillmentId: _.get(this.selectedFulfillment, 'id'),
      from: this.filtersConfig.range.dateStart,
      to: this.filtersConfig.range.dateEnd,
      accountIds: this.filtersConfig.bringozFilters.accountIds,
      agentIds: this.filtersConfig.bringozFilters.agentIds,
      logisticsVehicleIds: this.filtersConfig.bringozFilters.logisticsVehicleIds,
      isReturnDelivery: this.filtersConfig.bringozFilters.isReturnDelivery,
      schedulingRequired: this.filtersConfig.bringozFilters.schedulingRequired,
      noFromLocation: this.filtersConfig.bringozFilters.noFromLocation,
      noToLocation: this.filtersConfig.bringozFilters.noToLocation,
      approvalStatuses: this.filtersConfig.bringozFilters.approvalStatuses,
      obligateTimeWindow: this.filtersConfig.bringozFilters.obligateTimeWindow,
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      serviceAreaIds: this.filtersConfig.bringozFilters.serviceAreaIds,
      tags: this.filtersConfig.bringozFilters.tags,
      depotIds: this.filtersConfig.bringozFilters.depotIds,
      inRoute: this.filtersConfig.bringozFilters.inRoute,
      programTypes: this.filtersConfig.bringozFilters.programTypes,
      packagesIds: this.filtersConfig.bringozFilters.packagesIds,
      serviceTypes: this.filtersConfig.bringozFilters.serviceTypes,
      fulfillmentStepDisplayStatus: this.filtersConfig.bringozFilters.fulfillmentStepDisplayStatus,
      fulfillmentMileType: this.filtersConfig.bringozFilters.fulfillmentMileType,
      filterByCreatedAt: this.filtersConfig.filterByCreatedAt,
      displayStatusGroups: this.filtersConfig.bringozFilters.displayStatusGroups,
      dispatchType: this.filtersConfig.bringozFilters.dispatchType,
      selectedQuickFilterId: this.selectedQuickFilterId,
      noPickUpArea: this.filtersConfig.bringozFilters.noPickUpArea,
      noDropOffArea: this.filtersConfig.bringozFilters.noDropOffArea,
      noPickUpDepot: this.filtersConfig.bringozFilters.noPickUpDepot,
      noDropOffDepot: this.filtersConfig.bringozFilters.noDropOffDepot,
      noPickUpAccount: this.filtersConfig.bringozFilters.noPickUpAccount,
      noDropOffAccount: this.filtersConfig.bringozFilters.noDropOffAccount
    }, {notify: false, reload: false});
  }

  private _onExport(exportType) {
    const payload = {
      stepFilter: this._getStepFilterPayload(),
      fulfillmentFilter: {
        packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
      },
      searchTerm: this.searchTerm
    }
    this.fulfillmentService.exportFulfillmentSteps(payload, exportType);
  }

  private _initFulfillments(resetSelectedFulfillment) {
    this.fulfillments = [];
    if (resetSelectedFulfillment) {
      this.selectedFulfillment = undefined;
    }

    let fromLocationIds = [];
    let toLocationIds = [];

    // Service Areas Location
    if (!this.filtersConfig.bringozFilters.noPickUpArea) {
      fromLocationIds = fromLocationIds.concat(this.filtersConfig.bringozFilters.serviceAreaIds)
    }
    if (!this.filtersConfig.bringozFilters.noDropOffArea) {
      toLocationIds = toLocationIds.concat(this.filtersConfig.bringozFilters.serviceAreaIds)
    }
    // Depots Location
    if (!this.filtersConfig.bringozFilters.noPickUpDepot) {
      fromLocationIds = fromLocationIds.concat(this.filtersConfig.bringozFilters.depotIds)
    }
    if (!this.filtersConfig.bringozFilters.noDropOffDepot) {
      toLocationIds = toLocationIds.concat(this.filtersConfig.bringozFilters.depotIds)
    }
    // Accounts Location
    if (!this.filtersConfig.bringozFilters.noPickUpAccount) {
      fromLocationIds = fromLocationIds.concat(this.filtersConfig.bringozFilters.accountIds)
    }
    if (!this.filtersConfig.bringozFilters.noDropOffAccount) {
      toLocationIds = toLocationIds.concat(this.filtersConfig.bringozFilters.accountIds)
    }

    const filter = {
      stepFilter: {
        from: this.filtersConfig.range.dateStart,
        to: this.filtersConfig.range.dateEnd,
        accountIds: _.filter(this.filtersConfig.bringozFilters.accountIds, (id) => {
          return !_.includes(fromLocationIds.concat(toLocationIds), id);
        }),
        vehicleIds: this.filtersConfig.bringozFilters.logisticsVehicleIds,
        schedulingRequired: this.filtersConfig.bringozFilters.schedulingRequired,
        noFromLocation: this.filtersConfig.bringozFilters.noFromLocation,
        noToLocation: this.filtersConfig.bringozFilters.noToLocation,
        obligateTimeWindow: this.filtersConfig.bringozFilters.obligateTimeWindow,
        isReturn: this.filtersConfig.bringozFilters.isReturnDelivery,
        branchIds: this.filtersConfig.bringozFilters.branchIds,
        serviceAreaIds: _.filter(this.filtersConfig.bringozFilters.serviceAreaIds, (id) => {
          return !_.includes(fromLocationIds.concat(toLocationIds), id);
        }),
        tags: this.filtersConfig.bringozFilters.tags,
        routed: this.filtersConfig.bringozFilters.inRoute,
        programTypes: this.filtersConfig.bringozFilters.programTypes,
        approvalStatuses: this.filtersConfig.bringozFilters.approvalStatuses,
        types: this.filtersConfig.bringozFilters.serviceTypes,
        displayStatuses: this.filtersConfig.bringozFilters.fulfillmentStepDisplayStatus,
        depotIds: _.filter(this.filtersConfig.bringozFilters.depotIds, (id) => {
          return !_.includes(fromLocationIds.concat(toLocationIds), id);
        }),
        filterByCreatedAt: this.filtersConfig.filterByCreatedAt,
        agentIds: this.filtersConfig.bringozFilters.agentIds,
        firstMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'firstMile' ? true : undefined,
        middleMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'middleMile' ? true : undefined,
        lastMile: this.filtersConfig.bringozFilters.fulfillmentMileType === 'lastMile' ? true : undefined,
        excludeAttemptSubtypes: this.filtersConfig.bringozFilters.dispatchType ? (this.filtersConfig.bringozFilters.dispatchType === FulfillmentSubTypeType.ThirdParty ? [FulfillmentSubTypeType.Dispatch] : [FulfillmentSubTypeType.ThirdParty]) : undefined,
        displayStatusGroups: this.filtersConfig.bringozFilters.displayStatusGroups.filter(s => s !== 'Total'),
        fromLocationIds: fromLocationIds,
        toLocationIds: toLocationIds
      },
      fulfillmentFilter: {
        packageTypes: this.filtersConfig.bringozFilters.packagesIds.length ? this.filtersConfig.bringozFilters.packagesIds : undefined,
      },
      searchTerm: this.searchTerm
    }

    this._getTotals(filter);

    // this.fulfillmentService.getFulfillmentsByPage(this.page, this.size, filter)
    //   .then(fulfillments => {
    //     this.fulfillments = angular.copy(fulfillments);
    //     _.forEach(this.fulfillments.content, f => {
    //       this._addStepNumberToFulfillment(f);
    //     })
    //     if (resetSelectedFulfillment && this.selectedFulfillment) {
    //       this.selectedFulfillment = undefined;
    //     }
    //   })
    //   .finally(() => {
    //     this.isLoading = false;
    //   })
    this.fulfillmentFacadeService.removeAll();
    this.fulfillmentFacadeService.getPaginatedResult(this.page, this.size, filter);
  }

  private _addStepNumberToFulfillment(fulfillment) {
    _.forEach(fulfillment.fulfillmentSteps, (s, index) => {
      s.stepNumber = index + 1
    })
  }

  private _bulkActionsData() {
    const matchFilterStepsIds = _.chain(this.selectedSteps)
      .filter(function (selectedStep) {
        return selectedStep.matchFilter
      })
      .map(function (filteredStep) {
        return filteredStep.id
      })
      .value()

    const isNotMatchFilterStepsIds = _.chain(this.selectedSteps)
      .filter(function (selectedStep) {
        return !selectedStep.matchFilter
      })
      .map(function (filteredStep) {
        return filteredStep.id
      })
      .value()

    const selectedStepIds = _.map(this.selectedSteps, selectedStep => {
      return selectedStep.id;
    })

    return {
      matchFilterStepsIds: matchFilterStepsIds,
      isNotMatchFilterStepsIds: isNotMatchFilterStepsIds,
      selectedStepIds: selectedStepIds
    }
  }

  private _getTotals(filter) {
    const filters = angular.copy(filter);
    filters.stepFilter.displayStatusGroups = undefined;
    this.fulfillmentService.getFulfillmentsTotals(filters)
      .then((totals: any) => {
        this.fulfillmentsTotals = totals;
      })
  }

  private getSelectedStepsServicesIds(steps) {
    return _.chain(steps)
      .filter(s => {
        return s.attempts
      })
      .map(s => {
        return _.find(s.attempts, attempt => {
          return attempt.id === s.referenceId;
        }).id
      })
      .value()
  }

  private _getSelectedStatuses(): FulfillmentStepDisplayStatusGroupType[] {
    return Object.values(FulfillmentStepDisplayStatusGroupType).filter(
      (status) => this.selectedTotalsFilter[status]);
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLinesView', {
    bindings: {
      fulfillmentId: '<',
      dateRangeTemplateType: '<?',
      from: '<',
      to: '<',
      isLinesView: '<',
      accountIds: '<?',
      branchIds: '<?',
      schedulingRequired: '<?',
      noFromLocation: '<?',
      noToLocation: '<?',
      obligateTimeWindow: '<?',
      isReturnDelivery: '<?',
      serviceAreaIds: '<?',
      tags: '<?',
      depotIds: '<?',
      agentIds: '<?',
      inRoute: '<?',
      programTypes: '<?',
      packagesIds: '<?',
      serviceTypes: '<?',
      approvalStatuses: '<',
      logisticsVehicleIds: '<',
      fulfillmentStepDisplayStatus: '<?',
      fulfillmentMileType: '<?',
      filterByCreatedAt: '<?',
      displayStatusGroups: '<?',
      selectedQuickFilterId: '<?',
      doDispatch: '<?',
      dispatchType: '<?',
      noPickUpArea: '<?',
      noDropOffArea: '<?',
      noPickUpDepot: '<?',
      noDropOffDepot: '<?',
      noPickUpAccount: '<?',
      noDropOffAccount: '<?'
    },
    template: require('./fulfillment-lines-view.html').default,
    controller: fulfillmentLinesView
  });
